import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/ficha-vacinacao`

    return {
        index() {
            return repository.get(`${baseUrl}`);
        },
        getVacinas(params) {
            return repository.get(`${baseUrl}/vacina?${urlUtil.serialize(params)}`, params)
        },
        getUnidades(params) {
            return repository.get(`${baseUrl}/unidade?${urlUtil.serialize(params)}`, params)
        },
        getInfraestruturas(params) {
            return repository.get(`${baseUrl}/infraestrutura?${urlUtil.serialize(params)}`, params)
        },
        getProfissionais(params) {
            return repository.get(`${baseUrl}/profissional?${urlUtil.serialize(params)}`, params)
        },
        getEquipes(params) {
            return repository.get(`${baseUrl}/equipe?${urlUtil.serialize(params)}`, params)
        },
        getOcupacoes(params) {
            return repository.get(`${baseUrl}/ocupacao?${urlUtil.serialize(params)}`, params)
        },
        getPaciente(params) {
            return repository.get(`${baseUrl}/paciente?${urlUtil.serialize(params)}`, params)
        },
        getEstrategias(params) {
            return repository.get(`${baseUrl}/estrategia?${urlUtil.serialize(params)}`, params)
        },
        getDoses(params) {
            return repository.get(`${baseUrl}/dose?${urlUtil.serialize(params)}`, params)
        },
        getLotes(params) {
            return repository.get(`${baseUrl}/lote?${urlUtil.serialize(params)}`, params)
        },
        getFabricantes(params) {
            return repository.get(`${baseUrl}/fabricante?${urlUtil.serialize(params)}`, params)
        },
        list(params) {
            return repository.get(`${baseUrl}/list?${urlUtil.serialize(params)}`)
        },
        create() {
            return repository.get(`${baseUrl}/create`)
        },
        edit(id) {
            return repository.get(`${baseUrl}/${id}/edit`)
        },
        update(id, params) {
            return repository.put(`${baseUrl}/${id}`, params)
        },
        store(params) {
            return repository.post(`${baseUrl}`, params)
        },
        destroy(id) {
            return repository.delete(`${baseUrl}/${id}`)
        },
        destroyAll(id) {
            return repository.delete(`${baseUrl}/vacinacao/${id}`)
        },
        destroyOne(id) {
            return repository.delete(`${baseUrl}/item/${id}`)
        },
    }
}
